var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",on:{"click":_vm.hideModal}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"disabled":!_vm.changesAllowed},on:{"click":_vm.acceptChanges}},[_vm._v("Save")])])
}
var staticRenderFns = []

export { render, staticRenderFns }